/* errorElement de las rutas (QA-009): una excepción de render o de carga no debe tumbar la aplicación ni mostrar la
 * pantalla técnica de React Router. El detalle queda en la consola del navegador (telemetría); el usuario ve un mensaje
 * claro con Reintentar / Volver. */
import { useEffect } from 'react';
import { isRouteErrorResponse, useLocation, useNavigate, useRouteError } from 'react-router';
import { Button, Card } from '@/shared/ui';

export function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const location = useLocation();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  useEffect(() => {
    // Solo a la consola/telemetría: nunca al usuario.
    console.error('sgr: error de ruta', { path: location.pathname, error });
  }, [error, location.pathname]);
  return (
    <div style={{ maxWidth: 560, margin: '0 auto' }} data-testid="route-error">
      <Card title={notFound ? 'Página no encontrada' : 'No pudimos cargar esta sección'}>
        <p style={{ fontSize: 'var(--fs-sm)', marginTop: 0 }}>{notFound ? 'La dirección no existe o ya no está disponible.' : 'Ocurrió un problema al mostrar la información. Puedes intentarlo nuevamente; si persiste, avisa al administrador del SGR.'}</p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {!notFound && <Button onClick={() => window.location.reload()}>Reintentar</Button>}
          <Button variant="secondary" onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}>Volver</Button>
          <Button variant="ghost" onClick={() => navigate('/')}>Ir al inicio</Button>
        </div>
      </Card>
    </div>
  );
}
